module.exports = __webpack_public_path__ + "img/icon-danxiang.14b3584d.png";